import Config from '@config';
import { initializeServiceOrganizationsApi } from '@gasbi/shared/common/features/serviceOrganizations';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  serviceOrganizationsApi,
  useCreateServiceOrganizationMutation,
  useUpdateServiceOrganizationMutation,
  useGetServiceOrganizationByIdQuery,
  useGetServiceOrganizationsInfiniteQuery,
} = initializeServiceOrganizationsApi(
  Config.VITE_API_CLIENT_URL,
  axiosBaseQuery,
);
